module.exports = __webpack_public_path__ + "img/full0-min.96314bc1.png";